import React from "react";
import { Helmet } from "react-helmet-async";

import Subscriptions from "./Subscriptions";
import WebsiteLayout from "layouts/WebsiteLayout";

import { routes } from "routes/routes";

const SubscriptionsPage: React.FC = () => {
  return (
    <WebsiteLayout>
      <Helmet>
        <link
          rel="canonical"
          href={`${window.location.origin}${routes.subscriptions}`}
        />
      </Helmet>
      <Subscriptions />
    </WebsiteLayout>
  );
};

export default SubscriptionsPage;
